import type { components } from "../../../api/generated";
import type { DicMajorAliasMutation, DicMajorListParams, DicMajorMutation } from "../types";

export type DicMajorAliasItemRaw = components["schemas"]["DicMajorAliasItem"];

export type DicMajorItemRaw = components["schemas"]["DicMajorItem"];

export type DicMajorListPageRaw = components["schemas"]["DicMajorListPage"];

/** 映射标准专业分页查询参数。 */
export function mapDicMajorListQueryParams(params: DicMajorListParams) {
  return {
    page: params.page,
    page_size: params.pageSize,
    keyword: normalizeOptionalText(params.keyword),
    major_category: normalizeOptionalText(params.majorCategory),
    is_disabled: params.isDisabled,
    sort_field: params.sortField,
    sort_direction: params.sortDirection,
  };
}

/** 映射标准专业新增与编辑载荷。 */
export function mapDicMajorMutationPayload(payload: DicMajorMutation) {
  return {
    major_name: payload.majorName.trim(),
    major_category: payload.majorCategory.trim(),
    spell_code: payload.spellCode.trim(),
    sort_no: payload.sortNo,
    is_disabled: payload.isDisabled,
    remark: payload.remark.trim(),
  };
}

/** 映射标准专业别名新增与编辑载荷。 */
export function mapDicMajorAliasMutationPayload(payload: DicMajorAliasMutation) {
  return {
    alias_name: payload.aliasName.trim(),
    is_disabled: payload.isDisabled,
    remark: payload.remark.trim(),
  };
}

/** 归一化可选查询文本。 */
function normalizeOptionalText(value?: string) {
  const normalized = value?.trim();
  return normalized ? normalized : undefined;
}
